const inverterColumns = [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'deviceCode',
    key: 'deviceCode',
    width: 280
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 600
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
  },
  {
    zh: '平均频率(Hz)',
    en: 'Average Frequency(Hz)',
    dataIndex: 'avgFrequency',
    key: 'avgFrequency',
    tooltip: true
  },
  {
    zh: '上限频率(Hz)',
    en: 'Rated Frequency(Hz)',
    dataIndex: 'inverterTemperature',
    key: 'inverterTemperature',
    tooltip: true
  },
  {
    zh: '平均电流(A)',
    en: 'Average Current(A)',
    dataIndex: 'avgCurrent',
    key: 'avgCurrent',
    tooltip: true
  },
  {
    zh: '高温率',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage',
    fixed: 2
  }
]

export {
  inverterColumns
}
